import { ConfiguredColumn, ObjectDataRecord } from '@types'

export const mapCoreRowKeysToColumnCodes = (
  row: ObjectDataRecord,
  columns: ConfiguredColumn[] = []
): ObjectDataRecord => {
  const mappedRow: ObjectDataRecord = { ...row }

  for (const column of columns) {
    const sourceKey = column.value || column.code
    const targetKey = column.code

    if (sourceKey !== targetKey && row[sourceKey] !== undefined) {
      mappedRow[targetKey] = row[sourceKey]
    }
  }

  return mappedRow
}
